// Reusable functions to bind events
function bindCartAddons() {
  const addons = document.querySelectorAll(".cart-addon");

  addons.forEach(async (addon) => {
    const checkbox = addon.querySelector(".addon-checkbox");
    const variantId = checkbox.dataset.variantId;
    const toggle = addon.querySelector(".addon-toggle");
    const desc = addon.querySelector(".addon-description");

    // Pre-check if this variant is already in the cart
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const item = cart.items.find((i) => i.variant_id == variantId);
    if (item) {
      checkbox.checked = true;
      // Ensure addon description is in cart notes if item is already in cart
      const addonDescription = addon
        .querySelector(".addon-description")
        ?.textContent?.trim();
      if (addonDescription && !cart.note?.includes(addonDescription)) {
        await updateCartNotes(addonDescription, "add");
      }
    }

    toggle?.addEventListener("click", () => {
      desc.classList.toggle("open");
      toggle.querySelector(".addon-toggle-icon").textContent =
        desc.classList.contains("open") ? "−" : "+";
    });

    checkbox?.addEventListener("change", async () => {
      const addonDescription = addon
        .querySelector(".addon-description")
        ?.textContent?.trim();

      if (checkbox.checked) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        // Add addon description to cart notes
        if (addonDescription) {
          await updateCartNotes(addonDescription, "add");
        }
      } else {
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        const item = cart.items.find((i) => i.variant_id == variantId);
        if (item) {
          const removed = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
          if (removed.ok) {
            // Remove addon description from cart notes
            if (addonDescription) {
              await updateCartNotes(addonDescription, "remove");
            }
            await refreshCartDrawer(); // Refresh only after successful remove
          }
        }
      }
      await refreshCartDrawer();
    });
  });
}

function bindQuantityControls() {
  document
    .querySelectorAll(".cart-drawer-item__quantity-container")
    .forEach((container) => {
      const input = container.querySelector(".quantity-input");
      const increaseBtn = container.querySelector('[data-action="increase"]');
      const decreaseBtn = container.querySelector('[data-action="decrease"]');
      const removeBtn = container.querySelector(".remove-btn");

      const spinner = document.createElement("div");
      spinner.className = "spinner";
      spinner.innerHTML = `
      <svg class="spinner-icon" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
      </svg>
    `;

      const setLoading = (state) => {
        increaseBtn.disabled = state;
        decreaseBtn.disabled = state;
      };

      increaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        const newQty = parseInt(input.value) + 1;

        setLoading(true);
        if (await updateCart(key, newQty))
          await refreshCartDrawer((scrollToTop = true));
      });

      decreaseBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        let currentQty = parseInt(input.value);
        const maxQty = parseInt(input.max);
        console.log(currentQty, maxQty);
        if (currentQty > maxQty) currentQty = maxQty + 1;
        if (currentQty <= 1) return;
        setLoading(true);
        if (await updateCart(key, currentQty - 1))
          await refreshCartDrawer((scrollToTop = true));
      });

      removeBtn?.addEventListener("click", async () => {
        const key = getLineItemKey(container);
        removeBtn.disabled = true;
        removeBtn.innerHTML = `<span class="add-to-cart-spinner"></span>`;
        removeBtn.style.borderBottom = "none";
        if (await updateCart(key, 0)) await refreshCartDrawer();
      });
    });
}

function bindAddToCartButtons() {
  document
    .querySelectorAll(".cart-drawer-item__add-to-cart-btn")
    .forEach((btn) => {
      const variantId = btn.dataset.variantId;

      // Avoid duplicate listeners
      btn.removeEventListener("click", btn._boundHandler);

      // Define and store the handler
      const handler = async () => {
        if (!variantId) return;

        // Store original content to restore later
        const originalHTML = btn.innerHTML;

        // Add loading state
        btn.disabled = true;
        btn.innerHTML = `<span class="add-to-cart-spinner"></span>`;

        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });

          console.log(await res.json());
          await refreshCartDrawer();
        } catch (err) {
          console.log(err);
        } finally {
          // Restore original button
          btn.disabled = false;
          btn.innerHTML = originalHTML;
        }
      };

      btn._boundHandler = handler;
      btn.addEventListener("click", handler);
    });
}

const cartIcon = document.querySelector(".js-drawer-open-cart");
if (cartIcon) {
  cartIcon.addEventListener("click", function (e) {
    e.preventDefault();
    openCartDrawer();
  });
}

function openCartDrawer(newCart = true) {
  if (newCart) {
    refreshCartDrawer();
  }
  setTimeout(() => {}, 300); // Allow DOM to update before showing drawer
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  cartDrawer.classList.add("open");
  overlay.classList.add("show");
  document.body.style.overflow = "hidden";

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCartDrawer();
  });

  overlay.addEventListener("click", closeCartDrawer);
}

function closeCartDrawer() {
  const cartDrawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("cartDrawerOverlay");
  document.body.style.overflow = "";
  cartDrawer.classList.remove("open");
  overlay.classList.remove("show");
}

function updateShippingProgressBar() {
  const shippingProgressContainer = document.getElementById(
    "cart-shipping-progress"
  );
  if (!shippingProgressContainer) return;

  const subtotal = parseFloat(shippingProgressContainer.dataset.cartSubtotal);
  const threshold = parseFloat(
    shippingProgressContainer.dataset.freeShippingThreshold
  );
  const preMessage = shippingProgressContainer.dataset.cartPreMessage;
  const postMessage = shippingProgressContainer.dataset.cartPostMessage;
  const remaining = Math.max(0, threshold - subtotal).toFixed(2);
  const percentage = Math.min(100, (subtotal / threshold) * 100).toFixed(1);

  const shippingMessage = document.getElementById("shippingRemaining");
  const pdpShippingMessage = document.getElementById("pdp-shipping-message");
  const progressBar = document.getElementById("progressBarFill");

  if (shippingMessage) {
    shippingMessage.textContent =
      remaining > 0
        ? preMessage?.replace("[remainingForGoalFormatted]", `$${remaining}`)
        : postMessage;
  }
  if (pdpShippingMessage) {
    pdpShippingMessage.textContent =
      remaining > 0 ? `Add $${remaining} more for free shipping!` : postMessage;
  }
  if (progressBar) progressBar.style.width = `${percentage}%`;
}

const cartDrawer = document.querySelector("#cartDrawerContainer");
const getLineItemKey = (el) =>
  el.closest("[data-line-item-key]")?.dataset.lineItemKey;
const updateCart = async (lineKey, quantity) => {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    return res.ok;
  } catch (error) {
    console.log(error);
  }
};

const updateCartNotes = async (description, action) => {
  try {
    // Get current cart to retrieve existing notes
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    let currentNotes = cart.note || "";

    let newNotes = currentNotes;

    if (action === "add") {
      // Add the description to cart notes
      if (!currentNotes.includes(description)) {
        newNotes = currentNotes
          ? `${currentNotes}\n${description}`
          : description;
      }
    } else if (action === "remove") {
      // Remove the specific description
      newNotes = currentNotes
        .replace(`\n${description}`, "")
        .replace(description, "");
    }

    // Update cart notes
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: newNotes }),
    });
  } catch (error) {
    console.log("Error updating cart notes:", error);
  }
};

const restoreCartScroll = (cartScrollTop) => {
  const cartDrawer = document.getElementById("cartDrawer");
  if (cartDrawer) {
    cartDrawer.scrollTop = cartScrollTop;
  }
};

const refreshCartDrawer = async (scrollToTop) => {
  const cartScrollTop = document.getElementById("cartDrawer").scrollTop;
  const res = await fetch(
    window.location.pathname + "?sections=new-cart-drawer"
  );
  const data = await res.json();
  if (data["new-cart-drawer"] && cartDrawer) {
    cartDrawer.innerHTML = data["new-cart-drawer"];
    document.getElementById("cartDrawer")?.classList.add("open");
    document.getElementById("cartDrawerOverlay")?.classList.add("show");
    document.body.style.overflow = "hidden";
    bindCartAddons();
    bindQuantityControls();
    updateShippingProgressBar();
    bindAddToCartButtons();
    bindGiftWrapControls();
    bindMainGiftWrapCheckbox();
    if (scrollToTop) {
      restoreCartScroll(cartScrollTop);
    }
    const cartCount = document.getElementById("cart-drawer-item-count")?.dataset
      ?.cartCount;
    const bubble = document.querySelector(".cart-link__bubble");
    if (bubble && cartCount) {
      bubble.innerText = cartCount;
      // bubble.classList.toggle("cart-link__bubble--visible", cartCount > 0);
    }
    if (Number(cartCount) <= 0) {
      const pdpShippingMessage = document.getElementById(
        "pdp-shipping-message"
      );
      if (pdpShippingMessage) {
        pdpShippingMessage.textContent = "";
      }
    }
  }
};

// Gift Wrap Flyout Functions
function openGiftWrapFlyout() {
  const flyout = document.getElementById("giftWrapFlyout");
  if (flyout) {
    flyout.classList.add("open");
    // Ensure collapsible is open by default
    const collapsibleCheckbox = document.getElementById(
      "gift-wrap-collapsible-checkbox"
    );
    const collapsibleContent = document.getElementById(
      "giftWrapCollapsibleContent"
    );
    // const toggleIcon = document.getElementById("giftWrapToggleIcon");
    if (collapsibleCheckbox && collapsibleContent) {
      collapsibleCheckbox.checked = true;
      collapsibleContent.classList.add("open");
      // if (toggleIcon) {
      //   toggleIcon.textContent = "Details -";
      // }
    }
  }
}

function closeGiftWrapFlyout() {
  const flyout = document.getElementById("giftWrapFlyout");
  if (flyout) {
    flyout.classList.remove("open");
  }
}

// Toggle gift wrap collapsible
function toggleGiftWrapCollapsible() {
  const collapsibleCheckbox = document.getElementById(
    "gift-wrap-collapsible-checkbox"
  );
  const collapsibleContent = document.getElementById(
    "giftWrapCollapsibleContent"
  );
  // const toggleIcon = document.getElementById("giftWrapToggleIcon");

  if (collapsibleCheckbox && collapsibleContent) {
    if (collapsibleCheckbox.checked) {
      collapsibleContent.classList.add("open");
      // if (toggleIcon) {
      //   toggleIcon.textContent = "Details -";
      // }
    } else {
      collapsibleContent.classList.remove("open");
      // if (toggleIcon) {
      //   toggleIcon.textContent = "Details +";
      // }
    }
  }
}

// Bind gift wrap checkbox and textarea
function bindGiftWrapControls() {
  const giftNoteTextarea = document.getElementById("gift-note");
  const characterCount = document.querySelector(".character-count");
  const addGiftWrapBtn = document.getElementById("addGiftWrapBtn");
  const collapsibleCheckbox = document.getElementById(
    "gift-wrap-collapsible-checkbox"
  );

  // Bind collapsible toggle via checkbox
  if (collapsibleCheckbox) {
    collapsibleCheckbox.addEventListener("change", toggleGiftWrapCollapsible);
  }

  // Handle gift note character count and button enable/disable
  if (giftNoteTextarea && characterCount && addGiftWrapBtn) {
    const variantId = addGiftWrapBtn.dataset.variantId;

    // Check if gift wrap is already in cart
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const item = cart.items.find((i) => i.variant_id == variantId);
        if (item) {
          // If gift wrap is already in cart, load the gift note from properties
          if (item.properties && item.properties.gift_note) {
            giftNoteTextarea.value = item.properties.gift_note;
            characterCount.textContent = `${giftNoteTextarea.value.length}/500`;
            addGiftWrapBtn.disabled = false;
            addGiftWrapBtn.textContent = "Update Gift Wrap";
          }
        }
      });

    // Enable/disable button based on textarea input
    giftNoteTextarea.addEventListener("input", () => {
      const length = giftNoteTextarea.value.length;
      characterCount.textContent = `${length}/500`;

      // Enable button if there's text, disable if empty
      const hasText = giftNoteTextarea.value.trim().length > 0;
      addGiftWrapBtn.disabled = !hasText;
    });

    // Handle add gift wrap button click
    addGiftWrapBtn.addEventListener("click", async () => {
      const giftNote = giftNoteTextarea.value.trim();

      if (!giftNote || !variantId) return;

      // Add loading state
      addGiftWrapBtn.classList.add("loading");
      addGiftWrapBtn.disabled = true;
      const originalText = addGiftWrapBtn.textContent;

      try {
        // First, check if gift wrap is already in cart
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        const existingItem = cart.items.find((i) => i.variant_id == variantId);

        if (existingItem) {
          // Remove existing gift wrap item
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: existingItem.key, quantity: 0 }),
          });
        }

        // Add gift wrap product with gift note as property
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              gift_note: giftNote,
            },
          }),
        });

        // Close the flyout and refresh cart
        closeGiftWrapFlyout();
        await refreshCartDrawer();
      } catch (error) {
        console.error("Error adding gift wrap:", error);
        // Restore button state on error
        addGiftWrapBtn.classList.remove("loading");
        addGiftWrapBtn.disabled = false;
        addGiftWrapBtn.textContent = originalText;
      }
    });
  }
}

// Update gift wrap main checkbox state
function updateGiftWrapMainCheckbox() {
  const giftWrapContent = document.querySelector(".cart-giftwrap__content");
  const mainCheckbox = document.getElementById("gift-wrap-main-checkbox");

  if (!giftWrapContent || !mainCheckbox) return;

  const variantId = giftWrapContent.dataset.variantId;
  if (!variantId) return;

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const item = cart.items.find((i) => i.variant_id == variantId);
      mainCheckbox.checked = !!item;
    })
    .catch((error) => {
      console.error("Error checking gift wrap status:", error);
    });
}

// Bind main gift wrap checkbox to handle removal
function bindMainGiftWrapCheckbox() {
  const mainCheckbox = document.getElementById("gift-wrap-main-checkbox");
  const giftWrapContent = document.querySelector(".cart-giftwrap__content");

  if (!mainCheckbox || !giftWrapContent) return;

  const variantId = giftWrapContent.dataset.variantId;
  if (!variantId) return;

  // Remove existing listener to prevent duplicates
  mainCheckbox.removeEventListener("change", mainCheckbox._boundHandler);

  const handler = async (e) => {
    // Check if gift wrap is currently in cart
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const existingItem = cart.items.find((i) => i.variant_id == variantId);

    if (existingItem) {
      // If gift wrap is in cart and checkbox is being unchecked, remove it
      if (!mainCheckbox.checked) {
        try {
          // Remove the gift wrap item
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: existingItem.key, quantity: 0 }),
          });

          // Refresh cart drawer
          await refreshCartDrawer();
        } catch (error) {
          console.error("Error removing gift wrap:", error);
          // Revert checkbox state on error
          mainCheckbox.checked = true;
        }
      }
    } else {
      // If gift wrap is NOT in cart, prevent checkbox from being checked
      // and open the flyout instead
      mainCheckbox.checked = false;
      openGiftWrapFlyout();
    }
  };

  mainCheckbox._boundHandler = handler;
  mainCheckbox.addEventListener("change", handler);
}

// Initial bindings
bindCartAddons();
bindQuantityControls();
updateShippingProgressBar();
bindAddToCartButtons();
bindGiftWrapControls();
bindMainGiftWrapCheckbox();
